import { Component, Input, SimpleChanges, ElementRef, AfterViewChecked, OnInit, OnChanges, ViewEncapsulation, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { isPlatformServer } from '@angular/common';

import { AnalyticsUtilsService } from '../../shared/analytics-utils.service';
import { Product } from '../../models/product.model';
import { ProductService } from '../../services/product.service';
import { DeviceService } from '../../shared/device.service';
import { MapsService } from '../../services/maps.service';
import { AppSettings } from '../../settings/app.settings';
import {
  animate,
  keyframes,
  query,
  stagger,
  style,
  transition,
  trigger
} from '@angular/animations';
import { WindowScrollService } from '../../shared/window-sroll.service';
import { Subscription } from 'rxjs';


///  <reference path='../../../../node_modules/@types/jquery/index.d.ts'/>
///  <reference path='../../shared/types/smoothZoom.d.ts'/>

declare var $: any;

@Component({
  selector: 'product-route',
  templateUrl: './product-route.component.html',
  styleUrls: ['./product-route.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  animations: [
    trigger('listAnimation', [
      transition('* => *', [

        query(':enter', style({ opacity: 0 }), { optional: true }),

        query(':enter', stagger('100ms', [
          animate('1s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true }),

        query(':leave', stagger('100ms', [
          animate('1s ease-in', keyframes([
            style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ])
  ]
})
export class ProductRouteComponent implements OnInit,AfterViewChecked,OnChanges, OnDestroy {

  @Input() product: Product;
  @Input() mapOffset: number;
  public route: any;
  public routes: any;
  public isNode: boolean = false;
  public isMapOpened = true;
  public animationList: boolean = false;
  public openedWindow : number = 0;
  public previous: any;
  public listOfPointsAux: any[] = [];
  public listOfPoints: MeetingPoint[] = [];
  public hasNotMeetingPoint: boolean = false;
  public lat: number;
  public lng: number;
  public zoomMap: number;
  public gestureHandling: string;
  public scrollSubscription: Subscription = null;
  public showMaps: boolean = false;
  public device: string = '';
  public showMapButtonClicked: boolean = false;

  //ICON STYLE
  private icon = {
    url: require('../../../assets/images/location_mark.svg'),
    scaledSize: {
      height: 45,
      width: 28
    }
  };

  constructor(private element: ElementRef, private productService: ProductService,
    private analyticsUtils: AnalyticsUtilsService, private mapsService: MapsService, private windowScroll: WindowScrollService,
    @Inject(PLATFORM_ID) private platformId: Object, private deviceService: DeviceService) {
    this.isNode = isPlatformServer(this.platformId);
  }

  public ngOnInit() {
  }

  public ngAfterViewChecked() {
  }

  public ngOnChanges(change: SimpleChanges) {
    if (this.product != null ) {
      this.scrollSubscription = this.windowScroll.scroll$.subscribe(this.handleScroll.bind(this));
      if (this.product.routes != null) {
        this.routes = this.product.routes;
      }

      if (this.product.meetingPoints) {
        this.product.meetingPoints = this.removeDuplicates(this.product.meetingPoints, 'description');
        //TRANSLATE MEETPOINT
        this.listOfPoints = [];
        this.product.meetingPoints.map((meeting, index) => {
          this.listOfPoints.push({
            id: index,
            latitude: meeting.lat,
            longitude: meeting.lon,
            name: 'Meeting point ' + (index + 1),
            info: meeting.description
          })
          //INITIAL POINTS
          this.lat = this.listOfPoints[0].latitude;
          this.lng = this.listOfPoints[0].longitude;
          if (!this.lat || !this.lng) {
            this.hasNotMeetingPoint = true;
          } else {
            this.hasNotMeetingPoint = false;
          }
          this.listOfPointsAux = [];
          this.listOfPointsAux = [...this.listOfPoints];
          this.animationList = true;
        });
      }

      if (this.deviceService.device != 'mobile') {
        this.zoomMap = 14;
        this.device = this.deviceService.device;
        this.gestureHandling = 'cooperative';
      } else {
        this.zoomMap = 14;
        this.device = this.deviceService.device;
        this.gestureHandling = 'cooperative';
      }
      if (!this.isNode) {
        if (this.showMaps != true && this.windowScroll.getCurrentScroll() > this.mapOffset) {
          this.showMaps = true;
          // this.analyticsUtils.show_map();
        }
      }
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }

  //******    MAP HANDLER    *******/

  toggleItems() {
    if (!this.isNode) {
      if (!this.animationList && this.listOfPointsAux != null) {
        this.listOfPointsAux = [...this.listOfPoints];
          this.animationList = true;
      } else if (this.animationList) {
        this.listOfPointsAux = [];
        setTimeout(() => {
          this.animationList = false;
        }, 500);
      }
    }
  }

  clickedMarker(infowindow) {
    if (this.previous) {
        this.previous.close();
    }
    this.previous = infowindow;
 }

//  onChoseLocation(event){
//    this.lat = event.coords.lat;
//    this.lng = event.coords.lng;
//  }

//  onCenterChange(event) {
//    this.lat = event.lat;
//    this.lng = event.lng;
//  }

  infoToMaps(meetPoint: MeetingPoint) {
    this.lat = meetPoint.latitude;
    this.lng = meetPoint.longitude;
    this.openedWindow = meetPoint.id;
    this.isInfoWindowOpen(meetPoint.id);
  }

  /**
   * remove duplicates
   * @param myArr array
   * @param prop prop to iterate to delete
   */
  private removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

  private isInfoWindowOpen(id) {
    return this.openedWindow == id;
  }

  getMapImage(size: string) {
    if (this.product != null) {
      return `${this.deviceService.constructCloudfrontURL(AppSettings.ROUTE_IMAGES, size)}/${this.product.hopOnImage}`;
    }
    return '';
  }

  open(route: any) {
    this.isMapOpened = false;
    this.routes.forEach(r => {
      r.opened = false;
    });
    route.opened = true;
  }

  openMap() {
    this.routes.forEach(r => {
      r.opened = false;
    });
    this.isMapOpened = true;
  }

  splitStops(stops, mobile: boolean = false) {
    let result = [];
    if (stops && stops.length > 0){
      if (!mobile) {
        const size = stops.length;
        const mid = Math.ceil(size/2);
        result = [stops.slice(0, mid), stops.slice(mid)];
      } else {
        let __stops = stops.slice();
        while (__stops.length > 7) {
          result.push(__stops.splice(0, 7));
        }
        result.push(__stops.splice(0, __stops.length));
      }
    }
    return result;
  }

  /**
   * Looks for the route that contains a certain stop. Return empty string if not found.
   * @param stopName Name of the stop to look for
   * @param stopOrder Number of the stop
   * @param routes Array of routes that can contain the stop.
   */
  searchRouteName(stopName: string, stopOrder: string, routes: any[]): string {
    try {
      let result = '';
      routes.forEach(route => {
        let found = route.stops.find(stop => {
          return (stop.order == stopOrder && stop.name == stopName);
        });
        if (found != null){
          result = route.routeName;
        }
      });
      return result;
    } catch (ex) {
      return '';
    }
  }

  private handleScroll(currentScroll) {
    if (currentScroll > this.mapOffset) {
      this.showMaps = true;
    }
  }

  onShowMapClick() {
    this.showMapButtonClicked = true;
   }
}



class MeetingPoint {
  /** Meeting identifier */
  public id: number;
  /** Latitude of meeting point */
  public latitude: number;
  /** Longitude of meeting point */
  public longitude: number;
  /** Name of meeting point */
  public name: string;
  /** Info of meeting point */
  public info:string;
}